import { ActionTreeNode, TraverseCallbackFn } from './types.flow';

const traverse = (actionNode: ActionTreeNode, callback: TraverseCallbackFn) => {
  callback(actionNode);

  actionNode.children.forEach(child => traverse(child, callback));
};

export default traverse;
